import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';
import { INTERACTIVE_CLASSES } from './buttonStyles';

export interface SelectableCardProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    selected: boolean;
}

/**
 * A panel-surfaced button for picking one of a few rich options (an image
 * plus a caption) — e.g. the Team planet's race shipyard tabs. The selected
 * card takes the zone-accent border; the rest stay on the neutral surface.
 * Carries no role of its own: pass `role="tab"`/`aria-selected` (or
 * `aria-pressed`) for whatever group it sits in.
 */
export const SelectableCard = forwardRef<HTMLButtonElement, SelectableCardProps>(function SelectableCard(
    { selected, className, type = 'button', ...rest },
    ref,
) {
    return (
        <button
            ref={ref}
            type={type}
            className={cn(
                'flex items-center gap-3 rounded-panel border px-3 py-2 text-left active:scale-[0.99]',
                INTERACTIVE_CLASSES,
                selected
                    ? 'border-[color:var(--zone-accent)] bg-space-800'
                    : 'border-space-700 bg-space-900/70 hover:border-hairline-strong',
                className,
            )}
            {...rest}
        />
    );
});

export default SelectableCard;
